/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DevisConsultationAdminService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Suivi des devis envoyes en signature (par entreprise)
     * Pour `customer_id` : chaque devis ayant au moins un lien de signature, avec le client, le commercial, les statistiques de liens (`total`, `signed`, `pending`), la date du dernier lien et les consultations du client. Tableau vide si aucun lien. Version admin de `GET /devis_consulation`.
     * @param customerId
     * @returns any
     * @throws ApiError
     */
    public devisConsultationAdminIndex(
        customerId: number,
    ): CancelablePromise<(string | Array<string>)> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/devis-consultations',
            query: {
                'customer_id': customerId,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail du suivi d'un devis (admin)
     * Pour `customer_id` : le devis et son client, l'historique des consultations (`date`) et tous les liens de signature (`id`, `status`, `url`, `created_at`, signataire une fois signe).
     * @param idDevis
     * @param customerId
     * @returns any
     * @throws ApiError
     */
    public devisConsultationAdminShow(
        idDevis: string,
        customerId: number,
    ): CancelablePromise<{
        devis: {
            IDDEVIS: string;
            NUMERO_DEVIS: string;
            DEVIS_SIGNE: string;
            DATE_SIGNATURE: string;
            DATE_TRANSMISSION: string;
            DATE_CREATION: string;
            MONTANT_TTC: string;
            CLIENT: {
                IDCLIENT: string;
                NOM_COMPLET: string;
                EMAIL: string;
                PORTABLE: string;
            };
        };
        consultations: string;
        signature_links: string;
        timeline: string;
        stats: {
            total_consultations: string;
            total_links_created: string;
            has_active_link: string;
        };
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/devis-consultations/{idDevis}',
            path: {
                'idDevis': idDevis,
            },
            query: {
                'customer_id': customerId,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Creer un lien de signature (admin)
     * Meme comportement que `POST /signature-links/{id_devis}` mais pour l'entreprise `customer_id` : lien existant renvoye s'il est encore en attente, 400 si le devis est deja signe.
     * @param idDevis
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public devisConsultationAdminCreateSignatureLink(
        idDevis: string,
        requestBody: {
            customer_id: number;
        },
    ): CancelablePromise<{
        token: string;
        url: string;
        status: string;
        created_at: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/devis-consultations/{idDevis}/signature-link',
            path: {
                'idDevis': idDevis,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Revoquer les liens de signature (admin)
     * Invalide tous les liens en attente du devis pour l'entreprise `customer_id`. Reponse : `{ message, revoked_count }`.
     * @param idDevis
     * @param customerId
     * @returns any
     * @throws ApiError
     */
    public devisConsultationAdminRevokeSignatureLinks(
        idDevis: string,
        customerId: number,
    ): CancelablePromise<{
        message: string;
        revoked_count: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/devis-consultations/{idDevis}/signature-link',
            path: {
                'idDevis': idDevis,
            },
            query: {
                'customer_id': customerId,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
}
